import axios from 'axios';
import {
  PLUGIN_INSTALL_PLUGIN_BEGIN,
  PLUGIN_INSTALL_PLUGIN_SUCCESS,
  PLUGIN_INSTALL_PLUGIN_FAILURE,
  PLUGIN_INSTALL_PLUGIN_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { toast } from 'react-toastify';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function installPlugin(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_INSTALL_PLUGIN_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/plugins/`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: PLUGIN_INSTALL_PLUGIN_SUCCESS,
              data: res,
            });
            Mixpanel.track('Installed Plugin');
            toast.success('Installed Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: PLUGIN_INSTALL_PLUGIN_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to install Plugin');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Installation Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: PLUGIN_INSTALL_PLUGIN_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to install Plugin');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Installation Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissInstallPluginError() {
  return {
    type: PLUGIN_INSTALL_PLUGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLUGIN_INSTALL_PLUGIN_BEGIN:
      return {
        ...state,
        installPluginPending: true,
        installPluginError: null,
      };

    case PLUGIN_INSTALL_PLUGIN_SUCCESS:
      return {
        ...state,
        installPluginPending: false,
        installPluginError: null,
      };

    case PLUGIN_INSTALL_PLUGIN_FAILURE:
      return {
        ...state,
        installPluginPending: false,
        installPluginError: action.data.error,
      };

    case PLUGIN_INSTALL_PLUGIN_DISMISS_ERROR:
      return {
        ...state,
        installPluginError: null,
      };

    default:
      return state;
  }
}
